import apiClient from './client';

export interface SlackUser {
  id: string;
  name: string;
  realName: string;
  avatar: string;
}

export const settingsApi = {
  getSlackUsers: async (): Promise<string[]> => {
    const response = await apiClient.get<{ userIds: string[] }>('/settings/slack-users');
    return response.data.userIds;
  },

  updateSlackUsers: async (userIds: string[]): Promise<void> => {
    await apiClient.put('/settings/slack-users', { userIds });
  },

  getSlackWorkspaceUsers: async (): Promise<SlackUser[]> => {
    const response = await apiClient.get<{ users: SlackUser[] }>('/settings/slack-workspace-users');
    return response.data.users;
  },
};
